import { useQuery } from '@tanstack/react-query';
import { api, GrTierResponse } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseSubscriptionTiersReturn {
  tiers: GrTierResponse[];
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useSubscriptionTiers(): UseSubscriptionTiersReturn {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: queryKeys.gameRewards.subscriptionTiers(),
    queryFn: () => api.getGameRewardsTiers(),
    staleTime: 10 * 60 * 1000, // Tiers rarely change
  });

  return {
    tiers: data?.tiers ?? [],
    loading: isLoading,
    error: error instanceof Error ? error.message : isError ? 'Failed to load tiers' : null,
    refresh: () => {
      refetch();
    },
  };
}
